import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import MainLayout from './layout/MainLayout';
import HomePage from './pages/Home';
import AboutPage from './pages/About';
import HowItWorksPage from './pages/HowItWorks';
import CreditRatingPage from './pages/CreditRating';
import FundraisingPage from './pages/Fundraising';
import FaqPage from './pages/FAQ';
import PricingPage from './pages/Pricing';
import ContactPage from './pages/Contact';
import CountryNotListedPage from './pages/CountryNotListed';
import { TermsPage, PrivacyPage, CookiesPage, NotFoundPage } from './pages/Policies';
import DevSeoPage from './pages/DevSeo';
import SeoHead from './components/SeoHead';
import { useAppDispatch } from './hooks/redux';
import { detectCountry } from './features/geo/geoSlice';
import { writeStoredCountry } from './content/siteContent';

function GeoBootstrap() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    // Migrate legacy ?country= links into storage, then strip from the URL
    const params = new URLSearchParams(window.location.search);
    const legacy = params.get('country');
    if (legacy) {
      writeStoredCountry(legacy);
      params.delete('country');
      const next = `${window.location.pathname}${params.toString() ? `?${params}` : ''}${window.location.hash}`;
      window.history.replaceState({}, '', next);
    }
    void dispatch(detectCountry());
  }, [dispatch]);
  return null;
}

export default function App() {
  return (
    <>
      <GeoBootstrap />
      <SeoHead />
      <Toaster position="top-center" gutter={10} containerStyle={{ top: 16 }} toastOptions={{ style: { fontFamily: 'Inter, sans-serif' } }} />
      <Routes>
        <Route path="__dev/seo" element={<DevSeoPage />} />
        <Route element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="how-it-works" element={<HowItWorksPage />} />
          <Route path="credit-rating" element={<CreditRatingPage />} />
          <Route path="fundraising" element={<FundraisingPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="universal/not-listed" element={<CountryNotListedPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="cookies" element={<CookiesPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}
